const UUID = /^[\da-f]{8}-[\da-f]{4}-[1-8][\da-f]{3}-[89ab][\da-f]{3}-[\da-f]{12}$/i;

/** The ID selects a receipt; the authenticated API still authorizes its owner. */
export function fundingReceiptId(values: readonly string[]): string | null {
  const value = values[0];
  return values.length === 1 && value && UUID.test(value) ? value : null;
}
